import type { ReactNode } from "react";
import { useParams } from "react-router-dom";
import { useBusinesses } from "@/features/business/hooks/businessQueries";
import type { Business } from "@/features/business/types/businessTypes";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import { FormPageState } from "./FormPageState";

export function FormBusinessBoundary({ title, children }: { title: string; children: (business: Business) => ReactNode }) {
  const { businessId } = useParams<{ businessId: string }>();
  const businesses = useBusinesses();
  const { goToHome } = useAppNavigation();
  const business = businesses.data?.find(item => item.id === businessId);
  if (businesses.isLoading) return <FormPageState title={title}><LoadingSpinner message="Loading your business..." /></FormPageState>;
  if (businesses.error) return <FormPageState title={title}><ErrorState message={businesses.error.message} onRetry={() => void businesses.refetch()} /></FormPageState>;
  if (!business) return <FormPageState title={title}><EmptyState title="Business unavailable" message="This business is not available to your account." action={{ label: "Back to Home", onClick: goToHome }} /></FormPageState>;
  return children(business);
}
